/**
 * Clamp a requested chooser page into the available chooser page range.
 *
 * Composer chooser view models may carry `currentPage` as an initial backend
 * projection, while the UI also owns local page navigation after render.  This
 * helper centralizes the numeric guard so initialization and local navigation
 * use the same one-based page semantics without letting stale backend values
 * force the user back to page one on every render.
 */
export function clampChooserPage(value, totalPages) {
  const total = Math.max(1, Number(totalPages) || 1);
  const requested = Number.isFinite(Number(value)) ? Number(value) : 1;
  return Math.max(1, Math.min(total, requested));
}

/**
 * Resolve the first visible page when a new composer chooser is mounted.
 *
 * Backend chooser payloads can specify `currentPage` to indicate the initial
 * page for replay or restored state.  That value should be consumed only when
 * the chooser identity changes.  After initialization, `useComposerChooser`
 * must rely on local `chooserPage` so next/previous controls are not
 * overwritten by the immutable backend payload.
 */
export function resolveInitialChooserPage(composerChooser = null, totalPages = 1) {
  return clampChooserPage(composerChooser?.currentPage, totalPages);
}
